export default function initHero() {
  const heroEls = document.querySelectorAll(".js-hero");

  // Where el is the DOM element you'd like to test for visibility
  function isHidden(el) {
    return el.offsetParent === null;
  }

  if (heroEls) {
    heroEls.forEach((el, i) => {
      // get all images
      const heroImages = el.querySelectorAll("img");
      var heroImagesArray = Array.from(heroImages);

      let imgsrc = "";

      // get the src of the one that's visible
      heroImagesArray.forEach((img) => {
        if (!isHidden(img)) {
          imgsrc = img.src;
        }
      });

      // wait until it's loaded
      const testimg = new Image();
      testimg.src = imgsrc;

      testimg.decode().then(() => {
        el.classList.add("hero--animated");
      });
    });
  }
}
